/**
 * Issues Page - Workshop 4 Aligned
 *
 * Displays and manages quote issues reported by installer companies.
 * Support team can view, assign, and resolve issues.
 */

import PageHeader from '@/components/common/PageHeader'
import { BugOutlined } from '@ant-design/icons'
import { Alert } from 'antd'
import React from 'react'

export const IssuesPage: React.FC = () => {
  return (
    <div className="p-4 space-y-4">
      <PageHeader
        title="Issues"
        subtitle="View and manage quote issues reported by installer companies."
        breadcrumbs={[
          { label: 'Home', path: '/' },
          { label: 'Issues' },
        ]}
      />

      <div className="mt-6">
        <Alert
          type="info"
          icon={<BugOutlined />}
          showIcon
          message={
            <span className="font-semibold">Issues Page - Coming Soon</span>
          }
          description="This page will display quote issues that need attention from the support team. Features include issue filtering, assignment, status tracking, and resolution workflow."
        />
      </div>
    </div>
  )
}

export default IssuesPage
